import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { GlobalStore } from '../../store';
import { lockQueue, unlockQueue, setShowHelperToAssistants } from '../../actions/assistantActions';
import {
  openBroadcastModal,
  openSetMotdModal,
  openSetQueueInformationModal,
  openPurgeQueueModal,
  openBroadcastFacultyModal,
} from '../../actions/modalActions';
import { enableSounds, disableSounds } from '../../actions/soundActions';
import User from '../../models/User';
import Queue from '../../models/Queue';
import { Information, Lock, Megaphone, Sign, Trashbin, Unlock } from '../../viewcomponents/FontAwesome';

export default (props: any): JSX.Element | null => {

  const queue: Queue = props.queue;
  const onPurgeConfirmed: (() => void) | undefined = props.onPurgeConfirmed;

  const user = useSelector<GlobalStore, User | null>(store => store.user);
  const playSounds = useSelector<GlobalStore, boolean>(store => store.playSounds);
  const [isAssistant, setIsAssistant] = useState(user !== null && (user.isAssistantIn(queue.name)));
  const [isTeacher, setIsTeacher] = useState(user !== null && (user.isTeacherIn(queue.name)));

  useEffect(() => {
    setIsAssistant(user !== null && user.isAssistantIn(queue.name));
    setIsTeacher(user !== null && user.isTeacherIn(queue.name));
  }, [user, queue.name]);

  const dispatch = useDispatch();

  return (
    !isTeacher && !isAssistant
      ? null
      : <div className="col-12 mt-lg-3 my-3 p-0">
          <button
            className="btn btn-block dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false" >
            Options
          </button>
          <div className="dropdown-menu col-12 py-0 mb-2 grey-border" aria-labelledby="dropdownMenuButton">
            <div className="dropdown-item clickable yellow" onClick={() => dispatch(openBroadcastModal(queue.name))}><Megaphone /> Broadcast</div>
            <div className="dropdown-item clickable yellow" onClick={() => dispatch(openBroadcastFacultyModal(queue.name))}><Megaphone /> Broadcast faculty</div>
            <div className="dropdown-item clickable yellow" onClick={() => dispatch(openSetMotdModal(queue.name))}><Sign /> Set MOTD</div>
            <div className="dropdown-item clickable yellow" onClick={() => dispatch(openSetQueueInformationModal(queue.name))}><Information /> Set queue information</div>
            <div className="dropdown-item clickable red" onClick={() => dispatch(openPurgeQueueModal(queue.name, onPurgeConfirmed))}><Trashbin /> Purge queue</div>
            {
              queue.locked
                ? <div className="dropdown-item clickable" onClick={() => dispatch(unlockQueue(queue.name))}><Unlock /> Unlock queue</div>
                : <div className="dropdown-item clickable red" onClick={() => dispatch(lockQueue(queue.name))}><Lock /> Lock queue</div>
            }
            {
              isTeacher && (
                <div className="dropdown-item clickable yellow" onClick={() => dispatch(setShowHelperToAssistants(queue.name, !queue.showHelperToAssistants))}>
                  <input type="checkbox" readOnly checked={!queue.showHelperToAssistants} style={{ marginRight: '0.5em' }} />
                  Hide helper to assistants
                </div>
              )
            }
            <div className="dropdown-item clickable yellow" onClick={() => dispatch(playSounds ? disableSounds() : enableSounds())}>
              <input type="checkbox" readOnly checked={playSounds} style={{ marginRight: '0.5em' }} />
              Sounds
            </div>
          </div>
        </div>
  );
};
